import React from "react";
import styled from "styled-components";
import NEAPLogo from "../../assets/neat/neap_logo.svg";
import DesktopDeivceLogo from "../../assets/neat/desktop_deivce.svg";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f6ff;
`;
const Container = styled.div`
  width: 80%;
  height: 70%;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 16px 32px 0px rgba(221, 230, 237, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 0 80px 0;
  justify-content: center;
  gap: 97px;

  @media (max-width: 1024px) {
    gap: 60px;
  }

  @media (max-width: 860px) {
    gap: 40px;
  }

  @media (max-width: 548px) {
    gap: 24px;
  }

  @media (max-width: 480px) {
    height: 65%;
  }
`;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  img {
    width: 256px;
    @media (max-width: 480px) {
      width: 180px;
    }
  }
`;

const Header = styled.h6`
  color: #242424;
  text-align: center;
  font-family: Poppins;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

const Content = styled.p`
  color: #464646;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

function DeviceNotSupport({
  logo = NEAPLogo,
  icon = DesktopDeivceLogo,
  // title = "Heads up!",
  title = "SOMETHING WENT WRONG",
  // description = "Please switch to a desktop device to continue.",
  description = "Please try again later.",
  children,
}) {
  return (
    <Wrapper>
      <Container>
        {logo && <img src={logo} alt="" style={{ width: "234px" }} />}
        <ContentSection>
          <img src={icon} alt="" />
          <Header>{title}</Header>
          <Content>{description}</Content>

          {children}
        </ContentSection>
      </Container>
    </Wrapper>
  );
}

export default DeviceNotSupport;
